import type React from 'react';
import { TabsProvider } from './TabsContext';
import type { TabId } from './types';

export interface TabsProps {
  defaultTabId: TabId;
  children?: React.ReactNode;
  onTabChange?: (tabId: TabId) => void;
}

export const Tabs = ({ defaultTabId, children, onTabChange }: TabsProps) => (
  <TabsProvider
    defaultTabId={defaultTabId}
    onTabChange={onTabChange}
  >
    {children}
  </TabsProvider>
);
